export function formatNumber(num) {
  // 将数字转换为字符串，然后添加逗号分隔符
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
